module.exports = __webpack_public_path__ + "img/milestone-last-active.e6bacac8.png";